import { useEffect } from "react";
import useDevice from "src/hooks/useDevice";
import { BlurView, Text } from "src/swsh-native";
import {
	TAG_BORDER_RADIUS,
	TAG_HORIZONTAL_PADDING,
	TAG_VERTICAL_PADDING,
} from "../../../constants";
import { HandleTagSettled, TagsOverlayTag } from "../types";

const RenderTag = ({
	firstName,
	lastName,
	handleTagSettled,
	tag,
}: {
	firstName: string | null;
	lastName: string | null;
	handleTagSettled: HandleTagSettled;
	tag: TagsOverlayTag;
}) => {
	const { device } = useDevice();
	useEffect(() => {
		if (firstName == null || lastName == null) {
			if (!tag.didSettle) {
				handleTagSettled(tag.curKey);
			}
		}
	}, [firstName, lastName, tag.didSettle, tag.curKey, handleTagSettled]);

	if (!firstName || !lastName) return null;
	return (
		<BlurView
			testID={tag.labelDim ? "PhotoDetailTagVisible" : "PhotoDetailTagHidden"}
			onLayout={({ nativeEvent }) => {
				if (!tag.didSettle) {
					handleTagSettled(tag.curKey, nativeEvent.layout);
				}
			}}
			style={[
				{
					borderRadius: TAG_BORDER_RADIUS,
				},
				tag.labelDim
					? {
							width: tag.labelDim.width,
							height: tag.labelDim.height,
							justifyContent: "center",
							alignItems: "center",
							overflow: "hidden",
						}
					: {
							paddingHorizontal: TAG_HORIZONTAL_PADDING,
							paddingVertical: TAG_VERTICAL_PADDING,
						},
				tag.__debugColor ? { borderColor: tag.__debugColor, borderWidth: 1 } : {},
			]}
		>
			<Text xs={device === "mobile"} small={device === "desktop"}>
				{firstName} {lastName}
			</Text>
		</BlurView>
	);
};
export default RenderTag;
